import { Outlet } from 'react-router-dom';

import { CoachLayout } from '@/features/coach';

export const CoachRootLayout: React.FC = () => {
  return (
    <CoachLayout>
      <Outlet />
    </CoachLayout>
  );
};
